import { Link } from "react-router-dom";
import { Check, PenLine } from "lucide-react";

export const Contracts = ({ data }) => {
  const open = !!data.submitted_at;
  return (
    <section data-testid="account-contracts" className={`space-y-4 border border-[#1c1418]/20 p-5 md:p-8 ${open ? "" : "opacity-60"}`}>
      <h2 className="font-display text-3xl uppercase md:text-4xl">02 · {data.contracts.length > 1 ? "I tuoi contratti" : "Il tuo contratto"}</h2>
      {!open && <p className="text-sm">Invia prima snaps e portfolio: poi potrai firmare qui.</p>}
      {data.contracts.map((c, i) => (
        <div key={c.id} data-testid={`account-contract-${i}`} className="flex flex-col gap-3 border-t border-[#1c1418]/15 pt-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="font-display text-2xl uppercase leading-none">{c.label}</p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-[#1c1418]/70">
              {c.status === "signed" ? `Firmato il ${new Date(c.signed_at).toLocaleDateString("it-IT")}` : "Da firmare"}
            </p>
          </div>
          {c.status === "signed" ? (
            <Link to={`/contract/${c.token}`} data-testid={`account-contract-view-${i}`} className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] underline">
              <Check className="h-4 w-4 text-[#e9458f]" /> Vedi firmato
            </Link>
          ) : open && (
            <Link to={`/contract/${c.token}`} data-testid={`account-contract-sign-${i}`} className="flex items-center justify-center gap-2 bg-[#1c1418] px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white">
              <PenLine className="h-4 w-4 text-[#e9458f]" /> Leggi e firma
            </Link>
          )}
        </div>
      ))}
    </section>
  );
};
